module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr-ca":{"All":"Tous","South Side":"Versant Sud","North Side":"Versant Nord","The Edge":"Le Edge"}}')
  delete Component.options._Ctor
}
